import { render, staticRenderFns } from "./TutorialExcluirDados.vue?vue&type=template&id=7daf4084&scoped=true"
import script from "./TutorialExcluirDados.vue?vue&type=script&lang=js"
export * from "./TutorialExcluirDados.vue?vue&type=script&lang=js"
import style0 from "./TutorialExcluirDados.vue?vue&type=style&index=0&id=7daf4084&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7daf4084",
  null
  
)

export default component.exports